export enum BookingAction {
    delete = 'storniert',
    order = 'bestellt',
    buy = 'bezahlt',
    cashBoxOpening = 'kassenoeffnung'
}